import * as React from 'react';
import { truncate } from 'lodash';

import ActionLink from 'components/buttons/action-link/ActionLink';
import ActionButton from 'components/buttons/action-button/ActionButton';
import { ModalFrameFooter, ModalFrameInner, ModalFrameMessage } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';

import './collection-imported-modal-content.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./collection-imported-modal-content.i18n.json'));

const MAX_NAME_LENGTH = 70;

type Props = {
  onCloseModal: () => void,
  minHeight: number,
  collectionLabel: string,
  selectedCampaigns: Array<{ id: number, name: string }>,
  existingCreators: Array<string>
};

const CollectionImportedModalContent = (
  {
    collectionLabel,
    selectedCampaigns,
    minHeight,
    existingCreators,
    onCloseModal
  }: Props
): JSX.Element => {
  const creatorsToDisplay = existingCreators.length > 15 ? existingCreators.slice(0, 10) : existingCreators;
  const hiddenCreators = existingCreators.length > 15 ? existingCreators.length - 10 : 0;

  return (
    <React.Fragment>
      <ModalFrameInner
        minHeight={minHeight}
        verticalAlign="center"
      >
        <ModalFrameMessage
          message={__t('collection_imported_modal_content.heading_collection')}
        />
        <ModalFrameMessage
          message={`<strong>${collectionLabel}</strong>`}
        />
        <ModalFrameMessage
          message={__t('collection_imported_modal_content.heading_campaign')}
        />
        <div className="collection-imported-modal-content__result">
          {
            selectedCampaigns.map(campaign => (
              <div key={`campaign-${campaign.id}`}>
                <ActionLink
                  openInNewTab
                  size="inherit"
                  decoration="none"
                  className="collection-imported-modal-content__result-link"
                  link={`/campaigns/${campaign.id}/participants/shortlisted`}
                >
                  {truncate(campaign.name, { length: MAX_NAME_LENGTH })}
                </ActionLink>
              </div>
            ))
          }
        </div>
        {
          existingCreators.length > 0 && (
            <React.Fragment>
              <ModalFrameMessage
                message={__t('collection_imported_modal_content.heading_creators')}
              />
              <div
                className="collection-imported-modal-content__result collection-imported-modal-content__result-creators"
              >
                {creatorsToDisplay.map(creator => (
                  <div key={`creator-${creator}`}>{creator}</div>
                ))}
                {hiddenCreators > 0 && (
                  <div key="creators-more">
                    {__t('collection_imported_modal_content.additional_creators_label', {
                      hiddenCreators
                    })}
                  </div>
                )}
              </div>
            </React.Fragment>
          )
        }
      </ModalFrameInner>
      <ModalFrameFooter>
        <ActionButton
          color="secondary"
          onClick={onCloseModal}
        >
          {__t('collabary_common.action_button.close')}
        </ActionButton>
      </ModalFrameFooter>
    </React.Fragment>
  );
};

export default CollectionImportedModalContent;
